// extracted by mini-css-extract-plugin
module.exports = {"postCard":"postcard_postCard__y6SV6","postCategories":"postcard_postCategories__WbhTW","postTag":"postcard_postTag__Y39td","content":"postcard_content__psrPr"};